import { render, staticRenderFns } from "./LexinKeyboardLangPol.vue?vue&type=template&id=4ed24c42&"
import script from "./LexinKeyboardLangPol.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangPol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports